import _ from 'lodash';
import { RootState } from '../../store.model';

export const getCommanderLabelsSelector = (
  state: RootState,
  props: {
    groupId?: string;
    deviceId?: string;
  }
) => {
  return props.groupId
    ? _.get(
        state.devices.devicesGroupLabels,
        [props.deviceId as string, props.groupId as string],
        undefined
      )
    : _.get(state.devices.devicesLabels, props.deviceId as string);
};
